/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "wiman";
export var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["UNKNOWN"] = "UNKNOWN";
    DeviceStatus["STOPPED"] = "STOPPED";
    DeviceStatus["STARTED"] = "STARTED";
    DeviceStatus["UPGRADING"] = "UPGRADING";
})(DeviceStatus || (DeviceStatus = {}));
export var AuthMethod;
(function (AuthMethod) {
    AuthMethod["unknown"] = "unknown";
    AuthMethod["psk2"] = "psk2";
    AuthMethod["meter_auth"] = "meter_auth";
})(AuthMethod || (AuthMethod = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
